// subgraphX — subgraph columns from the chart's PAINTED frame.
//
// The CVD and DVP panes used to rebuild X from the live slot refs
// (viewWindowSizeRef / viewEndIndexRef / fractionalOffsetPxRef). The chart
// does not paint from those during a glide: it paints the placed end/frac,
// the lattice's whole-candle window, and then stretches the mesh by the X
// camera (scaleX about ax). The panes never applied that camera, so they
// drifted every glide frame. Reading lastFrameRef (written by drawCanvas at
// FRAME_DRAW, the same object the volume lane / heat / edge rows use) and
// applying the same camera makes column i land on the chart's column i.
//
// xS > 1 (the panes' "more history" control) compresses about the newest
// candle's right edge when it is on screen, else about the plot's right
// edge — exactly what the old frontAdj math did, written as one pivot.
//
// Returns null when there is no frame yet.
export function subgraphX(f, xS = 1, n = f ? f.total : 0) {
  if (!f || !(f.cw > 0) || !(f.plotWidth > 0) || !(n > 0)) return null
  const s = f.camScaleX > 0 ? f.camScaleX : 1
  const ax = Number.isFinite(f.camAx) ? f.camAx : 0
  const P = f.plotWidth
  const cwS = f.cw * s
  // screen left edge of candle 0, camera applied (same as heatCam)
  const X0 = ax + (P - (f.endIdx + 1) * f.cw + (f.panOffsetPx || 0) - ax) * s
  const k = xS > 1 ? xS : 1
  const Q = Math.min(P, X0 + n * cwS)          // newest candle's right edge, capped at plot edge
  const cw = cwS / k
  const x0 = Q - (Q - X0) / k
  const start = Math.max(0, Math.floor(-x0 / cw) - 1)
  const end = Math.min(n - 1, Math.ceil((P - x0) / cw))
  return { cw, x0, start, end, plotWidth: P, xLeft: (i) => x0 + i * cw }
}
